let styles = {};

styles.transparentBackground = {
    backgroundColor: 'transparent'
}

export default styles;


// WEBPACK FOOTER //
// ./styles/banner.js